import { CurrencyDisplayProps, CurrencyInputProps, DetailsFormFieldProps } from "models/propTypes/wintFormPropsTypes";
import DetailsFormBaseField from "./detailsFormBaseField";
import CurrencyDisplay from "../formDisplays/currencyDisplay";
import CurrencyInput from "../formFields/currencyInput";

const CurrencyField = (props: CurrencyInputProps & CurrencyDisplayProps & DetailsFormFieldProps) => {
  return (
    <DetailsFormBaseField<CurrencyInputProps, CurrencyDisplayProps>
      Display={CurrencyDisplay}
      Input={CurrencyInput}
      {...props}
    />
  );
};

export default CurrencyField;
